"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Button Group
 */
var EpsilonButtonGroup = /** @class */ (function () {
    /**
     * Class constructor
     * @param {{container: JQuery; setting: void; params: {value: number; id: string}}} control
     */
    function EpsilonButtonGroup(control) {
        this.control = control;
        this.context = control.container;
        this.handleEvents();
    }
    /**
     * Handle click events
     */
    EpsilonButtonGroup.prototype.handleEvents = function () {
        var self = this;
        this.context.on('click', '.epsilon-control-group > a', function (e) {
            e.preventDefault();
            var value = jQuery(this).attr('data-value');
            jQuery(this).siblings().removeClass('active');
            jQuery(this).addClass('active');
            if (!self.control.hasOwnProperty('repeater')) {
                self.control.setting.set(jQuery(this).attr('data-value'));
            }
            else {
                jQuery(this).parent().find('input').val(value).trigger('change');
            }
        });
    };
    return EpsilonButtonGroup;
}());
exports.EpsilonButtonGroup = EpsilonButtonGroup;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/button-group.ts
// module id = 3
// module chunks = 0